import { render, staticRenderFns } from "./jumbotron_main.vue?vue&type=template&id=006b7e7a&scoped=true&"
import script from "./jumbotron_main.vue?vue&type=script&lang=js&"
export * from "./jumbotron_main.vue?vue&type=script&lang=js&"
import style0 from "./jumbotron_main.vue?vue&type=style&index=0&id=006b7e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b7e7a",
  null
  
)

export default component.exports